import { IcoCanc } from 'icone';
import React, { useState } from 'react';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PeriodicReportingType } from '../PeriodicReporting';
import { deleteStatementByProjectIdAndStatementId } from 'lib/api_ts/periodicReportingApi';
import { useLocation } from 'react-router-dom-v5-compat';
import StatusBar from 'components/StatusBar';

interface PeriodicReportingDeleteModalProps {
	data: PeriodicReportingType;
	fetchData: () => void;
}

const PeriodicReportingDeleteModal: React.FC<PeriodicReportingDeleteModalProps> = ({ data, fetchData }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { pathname } = useLocation();
	const projectId = pathname.split('/')[2];
	const [isDeleting, setIsDeleting] = useState(false);

	const blankStatusBar = {
		status: undefined,
		message: '',
		timeout: undefined,
	};

	const [statusBar, setStatusBar] = useState(blankStatusBar);
	const resetStatusBar = () => {
		setStatusBar(blankStatusBar);
	};

	const handleDelete = async () => {
		setIsDeleting(true);
		setStatusBar({
			status: 'elaborating',
			message: 'Cancellazione Periodic Reporting in corso',
			timeout: false,
		});
		try {
			await deleteStatementByProjectIdAndStatementId(projectId, data.id);
			setStatusBar({
				status: 'success',
				message: 'Periodic Reporting cancellato con successo',
				timeout: true,
			});
			setTimeout(() => {
				setIsModalOpen(false);
				resetStatusBar();
				fetchData();
				setIsDeleting(false);
			}, 2000);
		} catch (error) {
			setIsDeleting(false);
			setStatusBar({
				status: 'error',
				message: 'Errore durante la cancellazione del Periodic Reporting',
				timeout: true,
			});
			setTimeout(() => {
				resetStatusBar();
			}, 2000);
		}
	};

	return (
		<>
			<OverlayTrigger placement="top" overlay={(props) => <Tooltip {...props}>Elimina</Tooltip>}>
				<span>
					<Button variant="link" onClick={() => setIsModalOpen(true)}>
						<IcoCanc className="second-color ico-small cancel" />
					</Button>
				</span>
			</OverlayTrigger>
			<Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Attenzione</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="my-3">
						<span>Sei sicuro di voler eliminare questo elemento?</span>
					</div>
					{statusBar.status ? (
						<StatusBar status={statusBar.status} message={statusBar.message} timeout={statusBar.timeout}>
							<></>
						</StatusBar>
					) : null}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="danger" onClick={() => handleDelete()} disabled={isDeleting}>
						Elimina
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};

export default PeriodicReportingDeleteModal;
